import React from "react";
import SponsoredRowCalculator from "./SponsoredRowCalculator";
import { useOutletContext } from "react-router-dom";

export function SponsoredRowCalculatorPage() {
  const { isAdmin } = useOutletContext();

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-200">
          Sponsored Row Calculator
        </h2>
        <p className="mt-2 text-sm text-gray-400">
          Calculate the cost to break even at a given number of minutes with
          specified CPM
        </p>
      </div>
      <div className="bg-[#18181B] rounded-xl shadow-xl shadow-black/20 p-4 sm:p-6">
        <div className="max-w-6xl mx-auto">
          <SponsoredRowCalculator isAdmin={isAdmin} />
        </div>
      </div>
    </div>
  );
}
